export const cuisineTypes = [
  { type: 'american', symbol: '🇺🇸' },
  { type: 'asian', symbol: '🍱' },
  { type: 'bar', symbol: '🍻' },
  { type: 'barbecue', symbol: '🍖' },
  { type: 'coffee', symbol: '☕️🇸' },
  { type: 'diner', symbol: '🍟' },
  { type: 'ice cream', symbol: '🍨🇸' },
  { type: 'italian', symbol: '🇮🇹' },
  { type: 'mediterranean', symbol: '🥙' },
  { type: 'mexican', symbol: '🌮' },
  { type: 'pizza', symbol: '🍕' },
  { type: 'ramen', symbol: '🍜' },
  { type: 'seafood', symbol: '🍤' },
  { type: 'spanish', symbol: '🇪🇸' },
  { type: 'sushi', symbol: '🍣 ' },
  { type: 'thai', symbol: '🇹🇭' },
  { type: 'other', symbol: '🌭' }
];



// WEBPACK FOOTER //
// ./client/components/common/cuisineTypes.js